import React, { useEffect, useState } from "react";
import { DatePicker, Select } from "antd";
import moment from "moment";
import Axios from "axios";
import { useSelector } from "react-redux";
import swal from "sweetalert";
import { Spinner } from "react-bootstrap";
import TableComponent from "../../../../_metronic/table/TableComponent";
import { CSVLink } from "react-csv";

const { Option } = Select;
const { RangePicker } = DatePicker;

export default function CustomerListByDate() {
  const {
    user: { accessToken, refreshToken },
  } = useSelector((state) => state.auth);

  const startOfMonth = moment().startOf("month");
  const endOfMonth = moment().endOf("month");
  const formatStart = startOfMonth.format("YYYY-MM-DD");
  const formatEnd = endOfMonth.format("YYYY-MM-DD");
  console.log();

  const [loading, setLoading] = useState(false);
  const [validationDate, setValidationDate] = useState(false);
  const [start_date_range, setstart_date_range] = useState(formatStart);
  const [end_date_range, setend_date_range] = useState(formatEnd);

  const [orderData, setOrderData] = useState([]);

  const [headers, setHeaders] = useState([]);
  const [customerWiseproductReport, setCustomerwiseproductReport] = useState(
    []
  );
  const [headers2, setHeaders2] = useState([]);
  const [customerDateWiseReport, setItemwiseproductReport] = useState([]);

  const getCustomerwiseproductReport = async () => {
    const { data } = await Axios.get(
      `${process.env.REACT_APP_API_URL}/report/customerListByTypeDate/7/${start_date_range}/${end_date_range}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
          refreshToken: refreshToken,
        },
      }
    );

    if (!data.error) {
      setCustomerwiseproductReport(data.data);
      const singleData = data.data[0];
      const makeHeader = [];
      for (let key in singleData) {
        makeHeader.push({ label: key, key: key });
      }
      setHeaders(makeHeader);
    } else {
      swal({
        title: "Something went wrong",
        icon: "error",
      });
    }
  };

  const getItemwiseproductReport = async () => {
    const { data } = await Axios.get(
      `${process.env.REACT_APP_API_URL}/report/customerListByTypeDate/${selectCompanyType}/${start_date_range}/${end_date_range}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
          refreshToken: refreshToken,
        },
      }
    );

    if (!data.error) {
      setItemwiseproductReport(data.data);
      const singleData = data.data[0];
      const makeHeader = [];
      for (let key in singleData) {
        makeHeader.push({ label: key, key: key });
      }
      setHeaders2(makeHeader);
    } else {
      swal({
        title: "Something went wrong",
        icon: "error",
      });
    }
  };

  useEffect(() => {
    getCustomerwiseproductReport();
    getItemwiseproductReport();
  }, []);

  useEffect(() => {
    if (end_date_range || start_date_range) {
      getCustomerwiseproductReport();
    }
  }, [end_date_range, start_date_range]);

  const data = React.useMemo(() => orderData, [orderData]);
  const columns = React.useMemo(
    () => [
      {
        Header: "#",
        accessor: (row, index) => (
          <div className="d-flex align-items-center pl-4">
            <div>
              <h4 className="text-dark-75 font-weight-bolder mb-1 font-size-sm">
                {index + 1}
              </h4>
            </div>
          </div>
        ),
        minWidth: 50,
        width: 50,
      },
      {
        Header: "Name",
        accessor: "name",
        paddingLeft: "0px",
      },
      {
        Header: "Email",
        accessor: "email",
        paddingLeft: "0px",
      },
      {
        Header: "Phone",
        accessor: "phone",
        paddingLeft: "0px",
      },
      {
        Header: "Registration Date",
        accessor: "reg_date",
        paddingLeft: "0px",
      },
      {
        Header: "Registration Via",
        accessor: "reg_via",
        paddingLeft: "0px",
      },
    ],
    [orderData]
  );

  const handleDateRange = (dateArr, date) => {
    const dates = [...dateArr];
    setstart_date_range(dates[0]);
    setend_date_range(dates[1]);
  };

  const handleSearch = async () => {
    setLoading(true);
    try {
      const { data } = await Axios.get(
        `${process.env.REACT_APP_API_URL}/report/customerListByTypeDate/${selectCompanyType}/${start_date_range}/${end_date_range}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${accessToken}`,
            refreshToken: refreshToken,
          },
        }
      );
      if (data.data.length === 0) {
        swal({
          title: "No Data Found!",
          icon: "info",
        });
      }
      if (!data.error) {
        data.data = data.data.map((data) => {
          const reg_date = data.reg_date
            ? moment(data.reg_date).format("YYYY-MM-DD HH:mm:ss")
            : "";
          return { ...data, reg_date };
        });
        setOrderData(data.data);
        setLoading(false);
      } else {
        if (data.data.length === 0) {
          swal({
            title: "No Data Found!",
            icon: "info",
          });
        }
        setLoading(false);
        setOrderData([]);
      }
    } catch (error) {
      setLoading(false);
    }
  };

  const [selectCompanyType, setSelectCompanyType] = useState();

  return (
    <div className="card">
      <div className="card-header border-0 d-flex justify-content-between pb-0">
        <h3 className="card-title mb-0">Customer List Ddate Wise Report</h3>
      </div>

      <div className="card-body">
        <div className="row mb-5">
          <div className="col-md-3">
            <label htmlFor="">Select Type</label>
            <Select
              className="form-control"
              placeholder="Select Type"
              onChange={(value) => setSelectCompanyType(value)}
            >
              <Option value="7">B2C</Option>
              <Option value="8">B2B</Option>
              <Option value="6">Wholesale</Option>
            </Select>
          </div>

          <div
            className="col-md-4"
            style={{ display: "flex", flexDirection: "column" }}
          >
            <label htmlFor="">Select Date</label>
            <RangePicker
              defaultValue={[startOfMonth, endOfMonth]}
              format={"YYYY-MM-DD"}
              onChange={(date, dateString) => handleDateRange(dateString, date)}
            />
            {validationDate ? (
              <p className="is_required">Please select start date first</p>
            ) : null}
          </div>

          <div className="col-md-2 align-self-center text-left mt-5">
            <button
              className="btn btn-primary w-50"
              onClick={() => handleSearch()}
              disabled={loading}
            >
              Search
              {loading && (
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                />
              )}
            </button>
          </div>

          <div className="col-md-3 align-self-center text-left mt-5">
            <CSVLink
              className="btn btn-info"
              data={orderData}
              headers={headers}
              filename="Customer Date wise  Report"
            >
              Download Report
            </CSVLink>
          </div>
        </div>
      </div>

      {orderData.length ? (
        <>
          <TableComponent
            data={data}
            columns={columns}
            lists={orderData}
            title="Customer List Date Wise Data"
            hideAddButton={true}
          />
        </>
      ) : (
        <h2 className="text-center py-5">Please select type and search </h2>
      )}
    </div>
  );
}
